import i18next from 'i18next';

i18next.addResources('en', 'AdelphiCaskFillings', {
  newCaskFillings: 'Add a new excel',
  periodId: 'Period ID',
  fillId: 'Fill ID',
  remanent: 'Remanent',
  expand: 'Expand',
  delete: 'Delete'
});
